import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, TextAlpha } from '@yonderland/andes-react';
import { useTranslation } from 'react-i18next';
import { ProductGroup } from '../components/product-group/ProductGroup';
import { I18N_NAMESPACES } from '../constants/i18nConstants';
import { ProductAddToBasketLocations } from '../enums/ActionEnums';
import { useProductTileHelpers } from '../hooks/useProductTileHelpers';
const AuthorLinkedProductsContainer = ({ productGroupId, products, name, }) => {
    const { handleWishlistToggle, handleUpdateCompareList, handleAddToBasket, compareItems } = useProductTileHelpers();
    const { t } = useTranslation(I18N_NAMESPACES.general);
    if (!products || products.length === 0) {
        return null;
    }
    return (_jsxs(Box, { paddingBlock: { base: '10', md: '12', xl: '16' }, children: [name && (_jsx(TextAlpha, { color: "emphasised", variant: "headingS", as: "h2", children: t('author.page.products.title', {
                    name: name,
                }) })), _jsx(ProductGroup, { removeOuterSpacing: true, addToBasket: (...args) => handleAddToBasket(...args, ProductAddToBasketLocations.PRODUCT_GROUP), collapsible: false, compareItems: compareItems, onWishListToggle: handleWishlistToggle, products: products, productGroupId: `product-group-${productGroupId}`, updateCompareList: handleUpdateCompareList })] }));
};
export default AuthorLinkedProductsContainer;
